import { render } from "./SettingsPricing.vue?vue&type=template&id=4d0bf717&scoped=true"
import script from "./SettingsPricing.vue?vue&type=script&lang=js"
export * from "./SettingsPricing.vue?vue&type=script&lang=js"

import "./SettingsPricing.vue?vue&type=style&index=0&id=4d0bf717&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d0bf717"]])

export default __exports__